import {
  ArnValidAuthConfig,
  ArnValidClientConfig,
  ArnValidTrackingConfig,
  ArnValidConditionConfig,
  ArnValidDataConfig,
  ArnValidI18nConfig,
  ArnValidNftConfig,
  ArnValidLogConfig,
} from '@arianee/arn-types';

export class ArnClientConfigImpl implements ArnValidClientConfig {
  constructor(
    /**
     * URL of the ARN Server to connect to.
     * This will typically include the project's api key.
     */
    readonly track: ArnValidTrackingConfig,
    readonly i18n: ArnValidI18nConfig,
    readonly auth: ArnValidAuthConfig,
    readonly nft: ArnValidNftConfig,
    readonly data: ArnValidDataConfig,
    readonly condition: ArnValidConditionConfig,
    readonly log: ArnValidLogConfig,
    readonly autoRegister: boolean
  ) {}
}
